module.exports = __webpack_public_path__ + "img/racing.92ccb1a1.svg";